import { CloseSharp, SaveSharp } from "@mui/icons-material";
import { Button, Grid, IconButton, Stack, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import * as React from "react";
import { useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "../../axiosInstances";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";

import { Formik } from 'formik';
import * as Yup from "yup";
const validationSchema = Yup.object().shape({
  Name: Yup.string()
    .required('Name is required!!!'),
  UserName: Yup.string()
    .required('Username is required!!!'),
  Password: Yup.string()
    .required('Password is required!!!'),
  ConfirmPassword: Yup.string()
    .required('Confirm Password is required!!!')
    .oneOf([Yup.ref('Password'), null], 'Passwords must match')

});

const User_RegEx = /^[a-zA-Z][a-zA-Z0-9-_]{3,23}$/;
const PW_RegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
export default function UserRegisterComp(props) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const { globalUser, setGlobalUser, globalToken } = useContext(ShoppingCartContext)

  let history = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [defaultTheme, setDefaultTheme] = useState(globalUser.Theme);
  const isUserNameOccupied = async (values) => {

    try {
      var formdata = new FormData();
      formdata.append("Username", values.Username);

      const response = await axios.post("/employees/CheckUserName", formdata, {
        headers: { "Content-Type": "application/json" }
      })

      if (response.data.data && response.data.data.length > 0) {

        return true
      } else {
        return false
      }

    } catch (ex) {

    }
    //errRef.current.focus();
  };
  const [errMsg, seterrMsg] = useState("");
  const handleSubmit = (values) => {
    if ((values.UserName !== values.OldUserName) && isUserNameOccupied(values)) {
      alert("The username is already used. Please change other username");
      return;
    }

    try {
      var fd = new FormData();
      fd.append("Id", globalUser.Id);

      fd.append("Username", values.UserName);
      fd.append("Password", values.Password);
      fd.append("Theme", defaultTheme);

      axios.post("/employees/updateUser", fd, {
        headers: {
          "Content-Type": "application/json",
          token: globalToken,
        },
      });
    } catch (err) {
    } finally {
      setGlobalUser({
        ...globalUser,
        Theme: defaultTheme
      })
      setOpen(false);
    }
  };
  const handleUserSubmit = async (values) => {

    try {
      var formdata = new FormData();
      formdata.append("UserName", values.OldUserName);
      formdata.append("Password", values.OldPassword);

      const response = await axios.post("/employees/ByUserName", formdata, {
        headers: { "Content-Type": "application/json" }
      })
      if (response.data) {
        handleSubmit(values);


        seterrMsg("");

      } else {
        if (response.status == 402) {
          seterrMsg("No Server Response");
        } else if (response?.status === 401) {
          seterrMsg("Username and Password is Incorrect");
        } else if (response?.status === 404) {
          seterrMsg("Unauthorize");
        } else if (response?.status === 400) {
          seterrMsg("This user is inactive");
        } else {
          seterrMsg("Login Faild");
        }
      }
    } catch (err) {
      sessionStorage.setItem("accessorToken", "");
      if (!err?.response) {
        seterrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        seterrMsg("No Server Response");
      } else if (err.response?.status === 401) {
        seterrMsg("Username and Password is Incorrect");
      } else if (err.response?.status === 404) {
        seterrMsg("Unauthorize");
      } else if (err?.response.status === 400) {
        seterrMsg("This user is inactive");
      } else {
        seterrMsg("Login Faild");
      }
    }
    //errRef.current.focus();
  };

  return (
    <div>
      <label onClick={handleClickOpen}>{props.icon ? props.icon : props.menuTtitle}</label>
      <Formik
        initialValues={{ ...props.data, Password: "", OldUserName: props.data.UserName, OldPassword: "" }}
        onSubmit={values => { handleUserSubmit(values) }}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ values, errors, touched, handleChange, isValid, handleSubmit }) => (

          <Dialog
            maxWidth="md"
            /*      PaperProps={{
               sx: {
                 height: '80vh',   // 80% of viewport height
                 maxHeight: '90vh',
               },
             }} */
            PaperProps={{
              style: {
                borderRadius: 24,
                backgroundColor: '#fffcf9', // Warm off-white
                boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
              }
            }}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText, height: 25, marginBottom: 2 }}>
              <Stack direction='row' style={{ flex: 1 }}>
                <div style={{ flex: 1 }}>
                  {props.Title}
                </div>
                <div style={{ marginLeft: 20, marginTop: -3, marginRight: -5 }}>
                  <IconButton style={{ background: theme.palette.primary.light, alignItems: 'center', justifyItems: 'center' }} onClick={() => setOpen(false)} size="small"><CloseSharp /></IconButton>
                </div>
              </Stack>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Grid container>

                  <Grid container>

                    <Grid item xs={12}>
                      Name of User: {globalUser.Name}
                    </Grid>
                    <Grid item xs={12}>
                      Old Username: {values.OldUserName}
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        size="small"
                        label="Old Password"
                        type="Password"
                        value={values.OldPassword}
                        onChange={//(e) => {
                          handleChange('OldPassword')// setName(e.target.value);
                        }//}
                        sx={{ width: "95%", marginBottom: 2, marginTop: 2 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      {errors.UserName && <span style={{ color: 'red' }}> {errors.UserName}</span>}
                    </Grid>
                    <Grid item xs={12}>
                      {errMsg && <span style={{ color: 'red' }}> {errMsg}</span>}
                    </Grid>
                    <hr></hr>
                    <Grid item xs={12}>
                      <TextField
                        size="small"
                        label="New Username"
                        value={values.UserName}
                        onChange={//(e) => {
                          handleChange('UserName')// setName(e.target.value);
                        }//}
                        sx={{ width: "95%", marginBottom: 2, marginTop: 2 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      {errors.UserName && <span style={{ color: 'red' }}> {errors.UserName}</span>}
                    </Grid>


                    <Grid item xs={12}>
                      <TextField
                        size="small"
                        variant="standard"
                        type="password"
                        label="New Password"
                        value={values.Password}
                        onChange={//(e) => {
                          handleChange('Password')// setName(e.target.value);
                        }//}
                        sx={{ width: "95%", marginBottom: 2 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      {errors.Password && <span style={{ color: 'red' }}> {errors.Password}</span>}
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        type="password"
                        variant="standard"
                        size="small"
                        label="Confirm New Password"
                        value={values.ConfirmPassword}
                        onChange={//(e) => {
                          handleChange('ConfirmPassword')// setName(e.target.value);
                        }//}
                        sx={{ width: "95%", marginBottom: 2 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      {errors.ConfirmPassword && <span style={{ color: 'red' }}> {errors.ConfirmPassword}</span>}
                    </Grid>
                  </Grid>

                </Grid>





              </DialogContentText>
            </DialogContent>
            <DialogActions
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                flexWrap: 'wrap',
              }}>
              <Button variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                endIcon={<SaveSharp />} onClick={handleSubmit} autoFocus>
                Update
              </Button>|
              <Button variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}

                endIcon={<CloseSharp />} onClick={() => handleClose()} autoFocus>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    </div>
  );
}
